<template>
    <div
        class="my-auto w-100 main-area"
        style="height: 100px !important; box-shadow:none; background:white; border-radius:0px"
        >
        <div style="text-align:center; font-size: 14px; margin-bottom: 5px;">
            <p style="color: #3c3c3c;">募集ポジション情報についてのお問合せ先　<a href="mailto:info@blm.co.jp">info@blm.co.jp</a></p>
        </div>
        <div class="site-title-custom row full justify-content-center">
            <p>
                <a href="https://www.blm.co.jp/" target="_blank" style="color:#232323;text-decoration: underline;">© Bloom Inc.</a>
            </p>
            <p>
                <a href="https://www.blm.co.jp/privacy.html" target="_blank">
                    プライバシーポリシー
                </a>
            </p>
            <p>
                <a href="https://www.blm.co.jp/security.html" target="_blank">
                  情報セキュリティ基本方針
                </a>
            </p>  
        </div>
        <!-- <div class="mb-5" style="text-align:center">
            <a href="https://www.blm.co.jp/" target="_blank" style="color:#232323;text-decoration: underline;">© Bloom Inc.</a>
        </div> -->
    </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
    .site-title-custom {
        padding-bottom: 0px !important;
    }
    a {
        color: #3c3c3c;
    }
    .full{
        gap:100px;
    }
   @media (max-width:550px){
    .full{
        gap:20px;
    }
    p {
        font-size: 12px;
    }
   }
</style>
